import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface TaxExemptionControlProps {
  name: string;
  id: string;
}

export function TaxExemptionControl({
  name,
  id,
}: TaxExemptionControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label={
        <CustomLabelWithTooltip
          color="primaryText"
          labelText="Tax exemption"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              Tax exemption should only be enabled for eligible 501(c)(3)
              corporations verified by Avalara.
            </Copy>
          }
        />
      }
    />
  );
}
